import { Component, Inject } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
    template: `
        <nb-card>
            <nb-card-header>שינויים בטופס</nb-card-header>
            <nb-card-body>נא לשמור בטרם הפקת טופס ואו שיתוף ואז נסה שנית<br> השמירה היא עבור יבוא <b>{{source}}</b></nb-card-body>
            <nb-card-footer>
                <button nbButton status="primary" (click)="confirm()">שמירה</button>&nbsp;
                <button nbButton status="basic" (click)="cancel()">ביטול</button>
            </nb-card-footer>
        </nb-card>
    `,
})
export class ConfirmationSaveDialogComponent {
    title: string;
    message: string;
    source: string;
    constructor(
        public nbDialogRef: NbDialogRef<ConfirmationSaveDialogComponent>
    ) {}

    confirm() {
        this.nbDialogRef.close(true);
    }

    cancel() {
        this.nbDialogRef.close(false);
    }
}
